import { Controller } from "@hotwired/stimulus";

/**
 * Menu Item Type Controller
 *
 * Shows only the fields that apply to the selected Menu Item Type: a content
 * page select, a custom link, or (for parents) the child items list. Each panel
 * lists the types it belongs to in `data-types`. Hidden fields keep their
 * values; the model clears whichever ones the saved type doesn't use.
 *
 * Also keeps a child item's accordion header in sync with its label, falling back
 * to the selected content page's title.
 *
 * Child items nest their own instance of this controller; Stimulus scopes
 * targets to the nearest controller, so a parent never toggles its child items'
 * panels.
 */
export default class extends Controller {
  static targets = ["typeSelect", "panel", "labelInput", "pageSelect", "title"];

  connect() {
    this.toggle();
  }

  toggle() {
    const type = this.typeSelectTarget.value;
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle(
        "d-none",
        !panel.dataset.types.split(" ").includes(type),
      );
    });
    this.updateTitle();
  }

  updateTitle() {
    if (!this.hasTitleTarget) return;

    const label = this.hasLabelInputTarget
      ? this.labelInputTarget.value.trim()
      : "";
    const page =
      this.hasPageSelectTarget && this.typeSelectTarget.value === "content_page"
        ? this.pageSelectTarget.selectedOptions[0]?.text.trim()
        : "";
    this.titleTarget.textContent =
      label || page || this.titleTarget.dataset.placeholder;
  }
}
